import mapToObject from '../util/map-to-object';

const PhonePerformanceMetricsProperties = [
  'ClickAndPhoneSpend',
  'PhoneSpend',
  'ManualCalls',
  'ClickCalls',
  'PhoneImpressions',
  'PTR',
  'AverageCPP',
];

export default mapToObject(
  PhonePerformanceMetricsProperties,
  property => `PhonePerformanceMetrics/${property}`
);
